import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, enableNetwork, disableNetwork } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCje6mIkoz5m_bTFzIMTFyZ9BTElx1It50",
  authDomain: "study-ai-52447.firebaseapp.com",
  projectId: "study-ai-52447",
  storageBucket: "study-ai-52447.firebasestorage.app",
  messagingSenderId: "434195758797",
  appId: "1:434195758797:web:3d190e46fd3e11494b7384",
  measurementId: "G-HFE2KVZRV0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const db = getFirestore(app);

// Create Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

export default app;
